import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContentDialog,
  SelectItem,
  SelectTriggerIcon,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

export const taskPriorities = [
  {
    value: "low",
    label: (
      <Badge variant="done" className="rounded-md">
        <span className="truncate">Low</span>
      </Badge>
    ),
    color: "var(--emerald-100)",
  },
  {
    value: "medium",
    label: (
      <Badge variant="medium" className="rounded-md">
        <span className="truncate">Medium</span>
      </Badge>
    ),
    color: "var(--yellow-100)",
  },
  {
    value: "high",
    label: (
      <Badge variant="high" className="rounded-md">
        <span className="truncate">High</span>
      </Badge>
    ),
    color: "var(--rose-100)",
  },
];

export default function TaskPrioritySelect({
  triggerClassName,
  placeholder = "Select priority",
  ...props
}) {
  return (
    <Select {...props}>
      <SelectTriggerIcon
        className={cn("border-none bg-transparent", triggerClassName)}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTriggerIcon>
      <SelectContentDialog className="[&_*[role=option]>span>svg]:shrink-0 [&_*[role=option]>span>svg]:text-muted-foreground/80 [&_*[role=option]>span]:end-2 [&_*[role=option]>span]:start-auto [&_*[role=option]>span]:flex [&_*[role=option]>span]:items-center [&_*[role=option]>span]:gap-2 [&_*[role=option]]:pe-8 [&_*[role=option]]:ps-2">
        {taskPriorities.map(({ value, label }) => (
          <SelectItem key={value} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContentDialog>
    </Select>
  );
}
